const LatestTips = ({tips}) => {
  if(tips.length === 0) {
    return <></>
  }

  tips.forEach(t => {
    if(typeof t.data === 'string') t.data = JSON.parse(t.data)
  })

  return (
    <div className="row">
      <div className="active-tips col-md-6">
        <h4>Tips</h4>
        {tips.map(item => (
          <div className="single-tip latest-table d-flex flex-column" key={item.id}>
            Datum - moze ovo i bolje
            <div className="tip-container d-flex justify-content-between align-self-stretch p-1">
              <div className="tip d-flex flex-column">
                <div className="teams">{item.data.home_name} vs {item.data.away_name}</div>
                <div className="tip">{item.data.title}</div>
              </div>
              <div className="odds text-center">{item.odds.toFixed(2)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LatestTips
